import React from 'react'
import { SvgIcon } from 'src/components/icons/svg-icon'
import { CLASS_PREFIX } from 'src/constants/'
import { textResources } from 'src/lang/de'
import { AUTH_CLS } from '../../auth/constants'
import './register_options.scss'

const cls = `${CLASS_PREFIX}register_options`

type IProps = {
  onSelectPrivateProfile: () => void
  onSelectPublicProfile: () => void
}

export const RegisterOptions: React.FC<IProps> = ({ onSelectPrivateProfile, onSelectPublicProfile }) => {
  return (
    <div className={cls}>
      <div>
        <div className={`${AUTH_CLS}__header`}>{textResources.authentication.selectProfileTitle}</div>
        <div className={`${AUTH_CLS}__subheader`}>
          {textResources.authentication.selectProfileSubtitle}
        </div>
      </div>
      <div className={`${cls}__tiles`}>
        <div className={`${cls}__tile`} onClick={onSelectPrivateProfile}>
          <SvgIcon name="Users/user-01" gradient />
          <div className={`${cls}__tile_description`}>
            <div className={`${cls}__tile_description_title`}>{textResources.authentication.privateProfile}</div>
            <div>{textResources.authentication.forPersonalUse}</div>
          </div>
        </div>
        <div className={`${cls}__tile`} onClick={onSelectPublicProfile}>
          <SvgIcon name="Users/user-square" gradient />
          <div className={`${cls}__tile_description`}>
            <div className={`${cls}__tile_description_title`}>{textResources.authentication.publicProfile}</div>
            <div>{textResources.authentication.forOrganizations}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
